import { SR_API_ACTION_GET_MARKET_LIST } from 'api/actionTypes';

export default async function getList({ state, apiClient }) {
  if (!state.get(['markets', 'listLoaded'])) {
    await apiClient.postWithState({
      action: SR_API_ACTION_GET_MARKET_LIST,
      state: state,
      onSuccess(markets) {
        markets.forEach((market) => {
          state.set(['markets', 'byId', market.id], market);
        });
        state.set(['markets', 'listLoaded'], true);
      },
    });
  }
}
